const DETAIL_MASS_PAYMENT_GETTERS = {
  loading: 'detailMassPayments/loading',
  id: 'detailMassPayments/id',
  actionLoading: 'detailMassPayments/actionLoading',
  reInviteLoading: 'detailMassPayments/reInviteLoading',
  formData: 'detailMassPayments/formData',
  selected: 'detailMassPayments/selected',
  total: 'detailMassPayments/total',
  totalAll: 'detailMassPayments/totalAll',
  items: 'detailMassPayments/items',
  search: 'detailMassPayments/search',
  filters: 'detailMassPayments/filters',
  sorting: 'detailMassPayments/sorting',
  successFileLoaded: 'detailMassPayments/successFileLoaded',
  formDataPaymentInfo: 'detailMassPayments/formDataPaymentInfo',
}

const DETAIL_MASS_PAYMENT_DISPATCHERS = {
  goToLoadDetail: 'detailMassPayments/goToLoadDetail',
  onSelected: 'detailMassPayments/onSelected',
  parsePayload: 'detailMassPayments/parsePayload',
  onSearch: 'detailMassPayments/onSearch',
  onSelectFilter: 'detailMassPayments/onSelectFilter',
  onClearSearchAndFilters: 'detailMassPayments/onClearSearchAndFilters',
  getQueryParams: 'detailMassPayments/getQueryParams',
  goToAddUser: 'detailMassPayments/goToAddUser',
  goToDeleteUsers: 'detailMassPayments/goToDeleteUsers',
  goToCopy: 'detailMassPayments/goToCopy',
  goToDownloadCSVExample: 'detailMassPayments/goToDownloadCSVExample',
  goToUploadInviteFile: 'detailMassPayments/goToUploadInviteFile',
  goToPayItems: 'detailMassPayments/goToPayItems',
  reInviteUser: 'detailMassPayments/reInviteUser',
  updateUser: 'detailMassPayments/updateUser',
  onSelectSort: 'detailMassPayments/onSelectSort',
  resetStore: 'detailMassPayments/resetStore',
  setSuccessFileLoaded: 'detailMassPayments/setSuccessFileLoaded',
  getPaymentInfo: 'detailMassPayments/getPaymentInfo',
  setId: 'detailMassPayments/setId',
}

export { DETAIL_MASS_PAYMENT_GETTERS, DETAIL_MASS_PAYMENT_DISPATCHERS }
